<div class="container-fluid px-4 pb-4">
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div><h4 class="mb-0 text-secondary">Inbound Productivity</h4></div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    @if(canManage) {
                        <dx-tag-box
                            [dataSource]="employeeDataSource"
                            valueExpr="id"
                            displayExpr="name"
                            [(value)]="employeeIds"
                            [showSelectionControls]="true"
                            selectAllMode="allPages"
                            [searchEnabled]="true"
                            [showClearButton]="true"
                            [maxDisplayedTags]="1"
                            [multiline]="false"
                            placeholder="All Employees"
                            stylingMode="filled"
                            [width]="240"
                            class="me-3"
                        ></dx-tag-box>
                    }
                    <dx-date-range-box [multiView]="false" [showClearButton]="true" [(value)]="dateRangeFilterValue" stylingMode="filled"></dx-date-range-box>
                    <dx-button stylingMode="text" class="ms-3" icon="export" (onClick)="onExport()"></dx-button>
                </div>
            </div>
            <div class="row align-items-center mb-4">
                <div class="col-sm-8 text-center position-relative">
                    <app-doughnut-chart
                        [from]="fromDate"
                        [to]="toDate"
                        [employeeId]="employeeIdsKey"
                        [centerText]="'Trailers'"
                        (loaded)="onMainChartLoaded($event)"
                        [loadData]="loadScoreData"
                        [formatMode]="'decimal'"
                        [palette]="palette"
                        [useCapitalCaseFormatting]="true">
                    </app-doughnut-chart>
                </div>

                <div class="col-sm-4 col-xl-3 offset-xl-1">
                    <div class="table-responsive rounded-1 border border-1">
                        <table class="table table-borderless mb-0">
                            <thead class="bg-light text-muted small text-uppercase">
                            <tr class="table-light">
                                <th>Type</th>
                                <th>Instances</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (detail of scoreData; track detail) {
                                    <tr class="border-top">
                                        <td class="text-muted">{{ detail.argument | capitalCase }}</td>
                                        <td class="text-muted">{{ detail.value | number:'1.0-2' }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card border-0 shadow-sm">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 class="mb-0 text-secondary">My Score Trending</h4>
                </div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    <dx-select-box
                        [items]="trendingFilterOptions"
                        [(value)]="trendingFilterValue"
                        valueExpr="value"
                        displayExpr="text"
                        stylingMode="filled"
                    >
                    </dx-select-box>
                </div>
            </div>

            <div class="mb-5">
                <app-trending
                    [aggregateType]="trendingFilterValue"
                    [loadData]="loadTrendingData"
                    [formatMode]="'decimal'"
                ></app-trending>
            </div>
        </div>
    </div>
</div>
